import * as Yup from 'yup';
import { CommonMessages } from 'src/validation/CommonMessages';

const ScheduleInpuValidationSchema = Yup.object().shape({

    work_start_time: Yup.string()
    .required(CommonMessages.required('Work Start Time')),

    work_date: Yup.string()
    .required(CommonMessages.required('Work Date')),

    tasks: Yup.array().of(
    Yup.object().shape({
        memo: Yup.string()
        .required(CommonMessages.required("memo")) // Common required message
        .max(200, CommonMessages.maxLength("memo", 200)), // Example: max length
    })
    ),
}).test(
    'tasks-or-holiday',
    'Please Select Task or Holiday Area.',
    (value) => {
      const tasks = value.tasks || [];
      const holidayArea = value.holidayArea || [];
      return tasks.length > 0 || holidayArea.length > 0;
    }
  );

export default ScheduleInpuValidationSchema;